import firebase from '@/firebase/firestore';

// データの保存場所
const state = {
  loadingStatus: true,
  addShow: false,
  noProject: false,
  projectinformation: {
    userId: '',
    projectDatas: [],
  },
  projectinpublic: [],
};

// Stateのデータを変更するファンクション
const mutations = {
  setLoading(state, loadingstatus) {
    state.loadingStatus = loadingstatus;
  },
  setId: (state, userid) => (state.projectinformation.userId = userid),
  setDatabase: (state, projectdatas) => (state.projectinformation.projectDatas = projectdatas),
  setDatabaseInPublic: (state, projectdatas) => (state.projectinpublic = projectdatas),
  setAddShow: (state, addshow) => (state.addShow = addshow),
  setNoProject: (state, noproject) => (state.noProject = noproject),
};

// データの前処理
const actions = {
  // プロジェクトの追加ウィンドウの表示
  async fetchAddShow({state,commit}){
    // 追加ウィンドウが表示されてない場合は表示し、「noproject」の表示をオフ
    if(state.addShow != true){
      commit('setAddShow', true);
      commit('setNoProject', false);
    }
    // 追加ウィンドウが表示されてる場合は非表示し、現在の格納データ数が０の場合「noproject」を表示
    else {
      commit('setAddShow', false);
      if(state.projectinformation.projectDatas <= 0){
        commit('setNoProject', true);
      }
    }
  },
  // 違うアカウントに存在する共通のコレクションを一気に取得
  async fetchDatabaseForBrowsing ({commit}){
    let projectdatas = [];
    const db = firebase.firestore().collectionGroup('projects');
    db
    .where('isPublic', '==', 'true')
    .orderBy('createdAt', 'desc')
    .get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
          console.log(doc.id, ' => ', doc.data());
      });
    });
    commit('setDatabaseInPublic', projectdatas);
  },
  async fetchDatabase ({ commit }, userid){
    // 01 ロード画面の表示
    let projectdatas = [];
    commit('setLoading', true)

    // 02 データのリアルタイム取得
    await firebase.firestore().collection('user').doc(userid).collection('projects').orderBy("createdAt","asc") //asc desc
    .onSnapshot((querySnapshot) => {
      querySnapshot.docChanges().forEach((change) => {
        // 02-01 データの追加を検出 → ロード画面の非表示 → noprojectの非表示
        if (change.type === "added") {
          projectdatas.unshift(change.doc.data());
        }
        // 02-02 データの編集を検出
        if (change.type === "modified") {
          projectdatas = [];
          projectdatas.push(change.doc.data());
          console.log("Modified : ", change.doc.data());
        }
        // 02-03 データの削除を検出 → ロード画面の非表示
        if (change.type === "removed") {
          projectdatas = [];
          projectdatas.push(change.doc.data());
        }
      });
    })
    // 03 プロジェクトデータをストアにセット
    commit('setDatabase', projectdatas)
    commit('setId', userid)
    commit('setLoading', false);
  },
  projectDetection({ commit }, state){
    // 04 プロジェクトデータ数の検出 → 0の場合はnoprojectを表示
    if(state.projectinformation.projectDatas.length <= 0){
      commit('setNoProject', true);
    }else{commit('setNoProject', false);}
  },
};

// データの抽出：これでDOM上でGettersのデータを使用できる !!データの変更はMUTATIONから!!
const getters = {
  projectInfo: state => state.projectinformation,
  projectInPublic: state => state.projectinpublic,
  loadingstatus: state => state.loadingStatus,
  addshow: state => state.addShow,
  noproject: state => state.noProject,
};

export default {
  state,
  getters,
  actions,
  mutations,
};

// 参考：https://www.youtube.com/watch?v=5lVQgZzLMHc
// Vue Cycle : https://qiita.com/chan_kaku/items/7f3233053b0e209ef355

// 参考：https://qiita.com/rerere0101/items/9d34c8278a8cbc1206de
// 1. State：初期データの宣言をする
// 2. Getters：Stateのデータに、ある決まった演算をして値を返す。データの上書きはしない。 (例. 商品データに、特定ユーザ向けで5%オフの演算をする場合)
// 3. Mutations：初期データを実際に更新する
// 4. Actions：初期データの更新をする演算のリクエストを受けて、下準備をした後、Mutationsを起動する。

// 参考：https://www.hypertextcandy.com/loading-with-vuex
// Loaderのオン/オフの方法

// グループコレクションのクエリ
// 参考 : https://firebase.google.com/docs/firestore/query-data/queries#collection-group-query
// 参考 : https://qiita.com/nanotumblr/items/36cfe8eb085c6cb9c30c
// Collection Group Query -> 違うユーザーデータでも、共有の名前のコレクションがあれば、それを一気にゲット！